<template>


    <div class="login-wrap">
        <router-link to="Forum">
            <img src="../assets/img/logow.png" class="logow">
        </router-link>

        <div class="ms-login">
            <el-card class="box-card">
                <div slot="header" >
                    <span>系统提示</span>
                </div>
                <div>
                     <p>
                         {{msg}}
                        <router-link v-if="islogin==0"  to="Login"><el-button type="warning" round>登录</el-button></router-link>
                     </p>
                </div>
            </el-card>
        </div>



<!--      <Lianjie/>-->

    </div>

</template>

<script>
    import Lianjie from "./Lianjie.vue";
    import {  lianjie} from '../api/common';

export default {
    name: "Tip",
    components: {
        Lianjie
    },

    data() {
        return{

            msg:'',
            lander:{},
            islogin:0,

        }
    },
    methods: {

        gotoA(a){
            window.open(lianjie[a],'_blank')
        },


    },created() {

        try {
            let lustr=this.$store.state.logininfo;
            if(lustr.trim().length==0){
                this.msg="请登录账号";
                this.islogin=0;
            }else{
                this.lander=JSON.parse(lustr);
                this.islogin=1;


                if(this.lander.role=='-1'){
                    this.msg="您目前不能访问论坛，请(原因："+this.lander.shMsg+")";
                    return;
                }   else  if(this.lander.role=='0'){
                    this.msg="您的注册信息待审核";
                    return;
                } else{
                    if(sessionStorage.systip!=undefined){
                        this.msg=sessionStorage.systip;
                        sessionStorage.removeItem("systip")
                    }
                }

            }



        }catch (e) {
            this.islogin=0;
        }



     }
};
</script>

<style scoped>


.login-wrap {
    position: relative;
    width: 100%;
    height: 100vh;
    background-image: url(../assets/img/loginback.jpg);
    background-size: 100% 100%;
}

.ms-login {
    position: absolute;

    top: 30%;
    width: 400px;
    width: 70%;
    margin: 0 15%;

    border-radius: 5px;
    background: rgba(255, 255, 255, 0.3);
    overflow: hidden;
}




    .logow{position: absolute;  top: 40%;width: 150px;
        margin: -220px 0 0 10%;}

</style>
